import { TermsAndConditions } from '@/components/TermsAndConditions';

export default TermsAndConditions;
